import React, { useState,useEffect,useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import "../../assets/Thankyou/css/Thankyou.scss";
import Footer from '../Includes/Layouts/Common/Footer';
import VisitorParamsContext from '../../Contexts/VisitorParams';
import { usePageLoad } from '../../Hooks/usePageLoad';
import { queryString } from '../../Utility/QueryString';
import { getPageName } from '../../Constants/PageNames';
const ThankyouBL = () => {
  const { visitorParameters } = useContext(VisitorParamsContext);
  const { savePageLoad, calledOnce } = usePageLoad();
  let uuid = visitorParameters.visitor_parameters.uuid;
  const query = new URLSearchParams(window.location.search);
  const splitName = query.get("split_name");
  localStorage.clear();

  useEffect(() => {
      if (!!uuid && !calledOnce) {
        const data = {
          uuid,
          page_name: getPageName("thankyou-bl"),
          status: "visited",
          source: "regular",
        };
        (async () => {
          await savePageLoad(
            visitorParameters.visitor_parameters,
            data,
            "visited_status",
            splitName,
            queryString,
            visitorParameters.data
          );
        })();
      }
    }, [uuid, calledOnce]);

  return (
    <>
      <div className="thankyou">
        <header>
          <div className="container">
            <div className="col-lg-12 col-12 text-center">
              <img src="/assets/img/logo.png" alt="" />
            </div>
          </div>
        </header>
          <div className="container ">
            <div className="row ">
              <div className="col-lg-10 offset-lg-1 col-sm-02 col-12 mp0  text-center animated bounceInDown">
                <img src="thumb.png" alt="" />
                <h1 className="animated zoomInUp">Thank you</h1>
                <p className="thankuparag">You have successfully submitted your claim</p>
              </div>
            </div>
          </div>
        <div className='footerclass'>
          <Footer />
        </div>
      </div>
    </>
  )
}

export default ThankyouBL;
